export default "__VITE_ASSET__cxxb997tO8ZV8wkN9buWFg__"